// extracted by css-extract-rspack-plugin
export default {"Copy":"Copy-module__Copy___oZTFY","copy":"Copy-module__Copy___oZTFY","Copy__icon":"Copy-module__Copy__icon___DsE5w","copyIcon":"Copy-module__Copy__icon___DsE5w"};